__turbopack_context__.v({
  "bar": "LoadingBar-module-scss-module__UzMepG__bar",
  "container": "LoadingBar-module-scss-module__UzMepG__container",
  "finished": "LoadingBar-module-scss-module__UzMepG__finished",
  "spinner": "LoadingBar-module-scss-module__UzMepG__spinner",
});
